import * as React from "react";
import styled from "styled-components";
import { useCalendarContext } from "../CalendarContext";
import { Colors } from "@blueprintjs/core";

const Container = styled.div`
  border-bottom: 1px solid black;
`;
const GutterDiv = styled.div`
  width: 100%;
  border-top: 1px solid ${Colors.WHITE};
  display: flex;
  padding-top: 5px;
  padding-left: 10px;
  font-size: large;
  background-color: ${Colors.GRAY2};

  color: ${Colors.WHITE};
`;

export function ResourceKeyColumn() {
  const { keyColumnWidthInPx, horizontalResources } = useCalendarContext();

  return (
    <Container style={{ width: keyColumnWidthInPx }}>
      {horizontalResources.keys.map((h, i) => (
        <GutterDiv
          style={{ height: horizontalResources.resourceRowHeightInPx }}
          key={i}
        >
          {horizontalResources.renderResourceKey(h)}
        </GutterDiv>
      ))}
    </Container>
  );
}
